import { render, staticRenderFns } from "./Layout1.vue?vue&type=template&id=ff1f8ab8"
import script from "./Layout1.vue?vue&type=script&lang=js"
export * from "./Layout1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports